



















import Vue, { PropType } from "vue";
import ListTile from "@/components/molecules/lists/ListTile.vue";
import { MaterialInputTemplate } from "@/lib/models";
import CheckboxBlankOutlineIcon from "icons/CheckboxBlankOutline.vue";
import CheckboxMarkedOutlineIcon from "icons/CheckboxMarkedOutline.vue";

interface Methods {
  onClick: (event: PointerEvent) => void;
  onCheck: (event: PointerEvent) => void;
}

interface Computed {
  itemName: string;
}

interface Props {
  template: MaterialInputTemplate;
  isListEditing: boolean;
  isDeleteEditing: boolean;
  checked: boolean;
  handleClassName: string;
  addDeleteTemplate: (template: MaterialInputTemplate) => void;
  refresh: () => void;
}

export default Vue.extend<unknown, Methods, Computed, Props>({
  components: { ListTile, CheckboxBlankOutlineIcon, CheckboxMarkedOutlineIcon },

  props: {
    template: Object as PropType<MaterialInputTemplate>,
    isListEditing: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    isDeleteEditing: {
      type: Boolean,
      default: false,
    },
    handleClassName: {
      type: String,
      default: "handle",
    },
    addDeleteTemplate: {
      type: Function,
      default: (_) => {},
    },
    refresh: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    itemName() {
      const { template } = this;
      return template.name;
    },
  },

  methods: {
    // event handle (button, checkbox, etc)

    onClick(_) {
      const { template, isListEditing, isDeleteEditing } = this;
      if (isListEditing || isDeleteEditing) return;

      if (template.id === this.$route.params.templateId) return;

      const params = { ...this.$route.params, templateId: template.id };
      if (this.$route.name) {
        this.$router.push({ name: this.$route.name, params });
      }
    },
    onCheck(_) {
      const { template, addDeleteTemplate } = this;
      addDeleteTemplate(template);
    },
  },
});
